import { render, staticRenderFns } from "./LayerParkingPermitAreas.vue?vue&type=template&id=4f690c6e"
import script from "./LayerParkingPermitAreas.vue?vue&type=script&lang=js"
export * from "./LayerParkingPermitAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports